import { Reducer, Dispatch, useReducer, createContext, PropsWithChildren } from 'react';

type BoundActions<A, T> = {
  [K in keyof T]: T[K] extends (d: Dispatch<A>) => infer R ? R : never;
};

type ContextValue<S, T, A> = {
  state: S;
} & BoundActions<A, T>;

type Action = {
  type: string;
  payload?: any;
};

export default function <S, A extends Action, T extends {}>(
  reducer: Reducer<S, A>,
  actions: T,
  initialState: S
) {
  const Context = createContext({
    state: initialState
  } as ContextValue<S, T, A>);

  const Provider = (props: PropsWithChildren) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const boundActions = {} as BoundActions<A, T>;

    for (const key in actions) {
      // @ts-ignore
      boundActions[key] = actions[key](dispatch);
    }

    return <Context.Provider value={{ state, ...boundActions }}>{props.children}</Context.Provider>;
  };

  return { Context, Provider };
}
